import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';

// const style = {
//   position: 'absolute',
//   top: '50%',
//   left: '50%',
//   transform: 'translate(-50%, -50%)',
//   width: 400,
//   bgcolor: 'background.paper',
//   border: '2px solid #000',
//   boxShadow: 24,
//   p: 4,
// };



export default function BasicModal() {


    const [values , setValues] = React.useState({
        name: '',
        email: '',
        subject: '',
        message: '',
        
      })
      
      const handleChange = (prop) => (event) => {
        setValues({...values , [prop]: event.target.value});
      }
      
      
      const handleSubmit= async (event)=>{
        event.preventDefault();
        const body = {
          name:values.name,
          email:values.email,
          subject:values.subject,
          message:values.message
      }

      handleClose();
    
      console.log(body);

      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      };
      
      try {
        const resp1 = await fetch('https://portfolio-sahil-rohera.herokuapp.com/sendContactData', requestOptions)

        if(resp1.ok){
          handleClick();
          // alert("submitted")
        }
        else
        // handleClicked();
          throw {msg: 'failed'}
      }
        
       catch (error) {
        console.log("Err ", error);
        error = (error.msg)?error.msg: "could not submit the form"; 
        // alert(error) ;
        handleClicked();
        
      }
    }


  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);


  const [openPopUp, setOpenPopUp] = React.useState(false);
  const [openPopUpError, setOpenPopUpError] = React.useState(false);

  const handleClicked = () => {
    setOpenPopUpError(true)
  }

  
  const handleClosePopError = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenPopUpError(false);
  };



  const handleClick = () => {
    setOpenPopUp(true);
  };

  const handleClosePop = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenPopUp(false);
  };

  return (
    <div className='contactMe' >

    <Snackbar open={openPopUp} autoHideDuration={3000} onClose={handleClose}>
            <Alert onClose={handleClosePop} severity="success" sx={{ width: '100%' }}>
              Sent Successfully
            </Alert>
          </Snackbar>

          <Snackbar open={openPopUpError} autoHideDuration={3000} onClose={handleClose}>
            <Alert onClose={handleClosePopError} severity="error" sx={{ width: '100%' }}>
              Something went wrong
            </Alert>
          </Snackbar>



        <Button onClick={handleOpen} variant="outlined"  style={{color : 'rgb(115, 32, 194)' , border : '1px solid rgb(115, 32, 194)'}}> Contact Me</Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className='ContactModal'>
            
          <Typography id="modal-modal-title" variant="h6" component="h2" style={{textAlign : 'center'}} >
            Contact Me
          </Typography>
          <form onSubmit={handleSubmit}>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
          <TextField id="outlined-basic" label="Name" variant="outlined" style={{width : '100%'}} value = {values.name} onChange={handleChange('name')}/>
     
          <TextField id="outlined-basic" label="Email Id" variant="outlined" style={{marginTop : '10px', width : '100%'}} value = {values.email} onChange={handleChange('email')} /> 
        
          <TextField id="outlined-basic" label="Subject" variant="outlined" style={{marginTop : '10px', width : '100%'}} value = {values.subject} onChange={handleChange('subject')} />

          <TextField
          id="outlined-multiline-static"
          label="Message"
          multiline
          rows={5}
          style={{marginTop : '10px', width : '100%'}}
          value = {values.message} onChange={handleChange('message')} 
        />
         <br />
         <br />
            <Button variant="outlined" type='submit'  >Submit</Button>

          </Typography>
          </form>
        </Box>
      </Modal>
    </div>
  );
}
